// eslint-disable-next-line no-unused-vars
var itemsIta = {
    "1": "Master Ball",
    "2": "Ultra Ball",
    "3": "Mega Ball",
    "4": "Poké Ball",
    "5": "Safari Ball",
    "6": "Rete Ball",
    "7": "Sub Ball",
    "8": "Minor Ball",
    "9": "Bis Ball",
    "10": "Timer Ball",
    "11": "Chic Ball",
    "12": "Premier Ball",
    "13": "Scuro Ball",
    "14": "Cura Ball",
    "15": "Velox Ball",
    "16": "Pregio Ball",
    "17": "Pozione",
    "18": "Antidoto",
    "19": "Antiscottatura",
    "20": "Antigelo",
    "21": "Sveglia",
    "22": "Antiparalisi",
    "23": "Ricarica totale",
    "24": "Pozione max",
    "25": "Iperpozione",
    "26": "Superpozione",
    "27": "Cura totale",
    "28": "Revitalizzante",
    "29": "Revitalizzante max",
    "30": "Acqua fresca",
    "31": "Gassosa",
    "32": "Lemonsucco",
    "33": "Latte Mumu",
    "34": "Polvenergia",
    "35": "Radicenergia",
    "36": "Polvocura",
    "37": "Vitalerba",
    "38": "Etere",
    "39": "Etere max",
    "40": "Elisir",
    "41": "Elisir max",
    "42": "Lavottino",
    "43": "Succo di bacca",
    "44": "Cenere magica",
    "45": "PS-su",
    "46": "Proteina",
    "47": "Ferro",
    "48": "Carburante",
    "49": "Calcio",
    "50": "Caramella rara",
    "51": "PP-su",
    "52": "Zinco",
    "53": "PP-max",
    "54": "Dolce gateau",
    "55": "Superguardia",
    "56": "Supercolpo",
    "57": "Attacco X",
    "58": "Difesa X",
    "59": "Velocit\u00e0 X",
    "60": "Precisione X",
    "61": "Attacco Speciale X",
    "62": "Difesa Speciale X",
    "63": "Pokébambola",
    "64": "Coda Skitty",
    "65": "Flauto blu",
    "66": "Flauto giallo",
    "67": "Flauto rosso",
    "68": "Flauto nero",
    "69": "Flauto bianco",
    "70": "Sale ondoso",
    "71": "Gusciondoso",
    "72": "Coccio rosso",
    "73": "Coccio blu",
    "74": "Coccio giallo",
    "75": "Coccio verde",
    "76": "Superrepellente",
    "77": "Repellente max",
    "79": "Repellente",
    "80": "Pietrasolare",
    "81": "Pietralunare",
    "82": "Pietrafocaia",
    "83": "Pietratuono",
    "84": "Pietraidrica",
    "85": "Pietrafoglia",
    "86": "Minifungo",
    "87": "Grande fungo",
    "88": "Perla",
    "89": "Grande perla",
    "90": "Polvostella",
    "91": "Pezzo stella",
    "92": "Pepita",
    "93": "Squama cuore",
    "94": "Miele",
    "95": "Fertilrapido",
    "96": "Fertilidro",
    "97": "Fertilsaldo",
    "98": "Fertilcolla",
    "99": "Radifossile",
    "100": "Fossilunghia",
    "101": "Helixfossile",
    "102": "Domofossile",
    "103": "Ambra antica",
    "104": "Fossilscudo",
    "105": "Fossilcranio",
    "106": "Osso raro",
    "107": "Pietrabrillo",
    "108": "Neropietra",
    "109": "Pietralbore",
    "110": "Pietraovale",
    "111": "Roccianima",
    "112": "Grigiosfera",
    "116": "Idromodulo",
    "117": "Voltmodulo",
    "118": "Piromodulo",
    "119": "Gelomodulo",
    "120": "???",
    "129": "???",
    "130": "???",
    "131": "???",
    "132": "???",
    "133": "???",
    "134": "Dolcecuore",
    "135": "Adamasfera",
    "136": "Splendisfera",
    "137": "Messaggio Inizio",
    "138": "Messaggio TVB",
    "139": "Messaggio Invito",
    "140": "Messaggio Grazie",
    "141": "Messaggio Chiedi",
    "142": "Messaggio Consiglio",
    "143": "Messaggio Risposta",
    "144": "Messaggio Ponte F",
    "145": "Messaggio Ponte L",
    "146": "Messaggio Ponte P",
    "147": "Messaggio Ponte V",
    "148": "Messaggio Ponte M",
    "149": "Baccaliegia",
    "150": "Baccastagna",
    "151": "Baccapesca",
    "152": "Baccafrago",
    "153": "Baccaperina",
    "154": "Baccamela",
    "155": "Baccarancia",
    "156": "Baccaki",
    "157": "Baccaprugna",
    "158": "Baccacedro",
    "159": "Baccafico",
    "160": "Baccakiwi",
    "161": "Baccamango",
    "162": "Baccaguava",
    "163": "Baccapaia",
    "164": "Baccalampon",
    "165": "Baccamora",
    "166": "Baccabana",
    "167": "Baccapera",
    "168": "Baccananas",
    "169": "Baccagrana",
    "170": "Baccalga",
    "171": "Baccaloquat",
    "172": "Baccamelon",
    "173": "Baccauva",
    "174": "Baccamodoro",
    "175": "Baccavena",
    "176": "Baccagostan",
    "177": "Baccambutan",
    "178": "Baccalemon",
    "179": "Baccamelos",
    "180": "Baccapalma",
    "181": "Baccacomero",
    "182": "Baccadurian",
    "183": "Baccartillo",
    "184": "Baccacao",
    "185": "Baccapasflo",
    "186": "Baccaparmen",
    "187": "Baccarindo",
    "188": "Baccamoya",
    "189": "Baccarosmel",
    "190": "Baccakebia",
    "191": "Baccanaca",
    "192": "Baccababa",
    "193": "Baccapayapa",
    "194": "Baccaitan",
    "195": "Baccaciofo",
    "196": "Baccacitrus",
    "197": "Baccahaban",
    "198": "Baccaxan",
    "199": "Baccababiri",
    "200": "Baccacinlan",
    "201": "Baccalici",
    "202": "Baccalongan",
    "203": "Baccasalak",
    "204": "Baccapitaya",
    "205": "Baccacocca",
    "206": "Baccalangsa",
    "207": "Baccambola",
    "208": "Baccaenigma",
    "209": "Baccaracolo",
    "210": "Baccacrela",
    "211": "Baccajaba",
    "212": "Baccaroam",
    "213": "Luminpolvere",
    "214": "Erbachiara",
    "215": "Crescicappa",
    "217": "Rapidartiglio",
    "218": "Calmanella",
    "219": "Mentalerba",
    "220": "Bendascelta",
    "221": "Roccia di re",
    "222": "Argenpolvere",
    "223": "Monetamuleto",
    "224": "Velopuro",
    "225": "Cuorugiada",
    "226": "Dente abissi",
    "227": "Squamabissi",
    "228": "Palla fumo",
    "229": "Pietrastante",
    "230": "Bandana",
    "231": "Fortunuovo",
    "232": "Mirino",
    "233": "Metalcopertura",
    "234": "Avanzi",
    "235": "Squama drago",
    "236": "Elettropalla",
    "237": "Sabbia soffice",
    "238": "Pietradura",
    "239": "Miracolseme",
    "240": "Occhialineri",
    "241": "Cintura nera",
    "242": "Calamita",
    "243": "Acqua magica",
    "244": "Beccaffilato",
    "245": "Velenaculeo",
    "246": "Gelomai",
    "247": "Spettrotarga",
    "248": "Cucchiaio torto",
    "249": "Carbonella",
    "250": "Dente di drago",
    "251": "Sciarpa seta",
    "252": "Upgrade",
    "253": "Conchinella",
    "254": "Marearoma",
    "255": "Distraroma",
    "256": "Fortunpugno",
    "257": "Metalpolvere",
    "258": "Osso spesso",
    "259": "Porro",
    "260": "Fascia rossa",
    "261": "Fascia blu",
    "262": "Fascia rosa",
    "263": "Fascia verde",
    "264": "Fascia gialla",
    "265": "Grandelente",
    "266": "Muscolbanda",
    "267": "Saviocchiali",
    "268": "Abilcintura",
    "269": "Creta luce",
    "270": "Assorbisfera",
    "271": "Vigorerba",
    "272": "Tossicsfera",
    "273": "Fiammosfera",
    "274": "Velopolvere",
    "275": "Focalnastro",
    "276": "Zoomlente",
    "277": "Plessimetro",
    "278": "Ferropalla",
    "279": "Rallentocoda",
    "280": "Destincomune",
    "281": "Fangopece",
    "282": "Rocciafredda",
    "283": "Roccialiscia",
    "284": "Rocciacalda",
    "285": "Rocciaumida",
    "286": "Presartiglio",
    "287": "Stolascelta",
    "288": "Vischiopunta",
    "289": "Vigorcerchio",
    "290": "Vigorfascia",
    "291": "Vigorlente",
    "292": "Vigorbanda",
    "293": "Vigorgliera",
    "294": "Vigorpeso",
    "295": "Disfoguscio",
    "296": "Granradice",
    "297": "Lentiscelta",
    "298": "Lastrarogo",
    "299": "Lastraidro",
    "300": "Lastrasaetta",
    "301": "Lastraprato",
    "302": "Lastragelo",
    "303": "Lastrapugno",
    "304": "Lastrafiele",
    "305": "Lastrageo",
    "306": "Lastracielo",
    "307": "Lastramente",
    "308": "Lastrabaco",
    "309": "Lastrapietra",
    "310": "Lastratetra",
    "311": "Lastradrakon",
    "312": "Lastratimore",
    "313": "Lastraferro",
    "314": "Bizzoaroma",
    "315": "Roccioaroma",
    "316": "Gonfioaroma",
    "317": "Ondaroma",
    "318": "Rosaroma",
    "319": "Fortunaroma",
    "320": "Puroaroma",
    "321": "Copertura",
    "322": "Elettritore",
    "323": "Magmatore",
    "324": "Dubbiodisco",
    "325": "Terrorpanno",
    "326": "Affilartiglio",
    "327": "Affilodente",
    "328": "MT001",
    "329": "MT002",
    "330": "MT003",
    "331": "MT004",
    "332": "MT005",
    "333": "MT006",
    "334": "MT007",
    "335": "MT008",
    "336": "MT009",
    "337": "MT010",
    "338": "MT011",
    "339": "MT012",
    "340": "MT013",
    "341": "MT014",
    "342": "MT015",
    "343": "MT016",
    "344": "MT017",
    "345": "MT018",
    "346": "MT019",
    "347": "MT020",
    "348": "MT021",
    "349": "MT022",
    "350": "MT023",
    "351": "MT024",
    "352": "MT025",
    "353": "MT026",
    "354": "MT027",
    "355": "MT028",
    "356": "MT029",
    "357": "MT030",
    "358": "MT031",
    "359": "MT032",
    "360": "MT033",
    "361": "MT034",
    "362": "MT035",
    "363": "MT036",
    "364": "MT037",
    "365": "MT038",
    "366": "MT039",
    "367": "MT040",
    "368": "MT041",
    "369": "MT042",
    "370": "MT043",
    "371": "MT044",
    "372": "MT045",
    "373": "MT046",
    "374": "MT047",
    "375": "MT048",
    "376": "MT049",
    "377": "MT050",
    "378": "MT051",
    "379": "MT052",
    "380": "MT053",
    "381": "MT054",
    "382": "MT055",
    "383": "MT056",
    "384": "MT057",
    "385": "MT058",
    "386": "MT059",
    "387": "MT060",
    "388": "MT061",
    "389": "MT062",
    "390": "MT063",
    "391": "MT064",
    "392": "MT065",
    "393": "MT066",
    "394": "MT067",
    "395": "MT068",
    "396": "MT069",
    "397": "MT070",
    "398": "MT071",
    "399": "MT072",
    "400": "MT073",
    "401": "MT074",
    "402": "MT075",
    "403": "MT076",
    "404": "MT077",
    "405": "MT078",
    "406": "MT079",
    "407": "MT080",
    "408": "MT081",
    "409": "MT082",
    "410": "MT083",
    "411": "MT084",
    "412": "MT085",
    "413": "MT086",
    "414": "MT087",
    "415": "MT088",
    "416": "MT089",
    "417": "MT090",
    "418": "MT091",
    "419": "MT092",
    "426": "MT099",
    "427": "MT100",
    "428": "Esplorokit",
    "429": "Bottinosacca",
    "430": "Libro regole",
    "432": "Scheda punti",
    "433": "Note di viaggio",
    "434": "Portabolli",
    "435": "Scatola chic",
    "436": "Bollosacca",
    "437": "Blocco amici",
    "438": "Chiave impianto",
    "439": "Amuleto antico",
    "441": "Catena rossa",
    "443": "Cercasfide",
    "444": "Salvadanaio",
    "448": "Sprayduck",
    "449": "Portapoffin",
    "451": "Chiave suite",
    "452": "Lettera Oak",
    "453": "Piumalunare",
    "454": "Scheda soci",
    "455": "Flauto cielo",
    "456": "Biglietto nave",
    "458": "Magmapietra",
    "459": "Pacco",
    "460": "Coupon 1",
    "461": "Coupon 2",
    "462": "Coupon 3",
    "463": "Chiave magazzino",
    "464": "Rimedio segreto",
    "467": "Chiave segreta",
    "468": "Ghicobox",
    "469": "Registro Unown",
    "470": "Piantabacche",
    "472": "Carta blu",
    "473": "Coda Slowpoke",
    "475": "Apriporta",
    "476": "Chiave sotterr.",
    "477": "Annaffiatoio",
    "478": "Squama rossa",
    "479": "Strumento perso",
    "480": "Superpass",
    "481": "Pezzo di macchinario",
    "482": "Ala d'argento",
    "483": "Ala d'iride",
    "484": "Uovo mistero",
    "485": "Ghicocca rossa",
    "486": "Ghicocca blu",
    "487": "Ghicocca gialla",
    "488": "Ghicocca verde",
    "489": "Ghicocca rosa",
    "490": "Ghicocca bianca",
    "491": "Ghicocca nera",
    "492": "Rapid Ball",
    "493": "Level Ball",
    "494": "Esca Ball",
    "495": "Peso Ball",
    "496": "Love Ball",
    "497": "Friend Ball",
    "498": "Luna Ball",
    "499": "Gara Ball",
    "501": "Album",
    "502": "Lettore GB",
    "504": "Iramella",
    "505": "Scheda dati 01",
    "506": "Scheda dati 02",
    "507": "Scheda dati 03",
    "508": "Scheda dati 04",
    "509": "Scheda dati 05",
    "510": "Scheda dati 06",
    "511": "Scheda dati 07",
    "512": "Scheda dati 08",
    "513": "Scheda dati 09",
    "514": "Scheda dati 10",
    "515": "Scheda dati 11",
    "516": "Scheda dati 12",
    "517": "Scheda dati 13",
    "518": "Scheda dati 14",
    "519": "Scheda dati 15",
    "520": "Scheda dati 16",
    "521": "Scheda dati 17",
    "522": "Scheda dati 18",
    "523": "Scheda dati 19",
    "524": "Scheda dati 20",
    "525": "Scheda dati 21",
    "526": "Scheda dati 22",
    "527": "Scheda dati 23",
    "528": "Scheda dati 24",
    "529": "Scheda dati 25",
    "530": "Scheda dati 26",
    "531": "Scheda dati 27",
    "532": "Sfera verde",
    "533": "Capsula scrigno",
    "534": "Gemma rossa",
    "535": "Gemma blu",
    "536": "Misticristal",
    "537": "Squama bella",
    "538": "Evolcondensa",
    "539": "Pietralieve",
    "540": "Bitorzolelmo",
    "541": "Palloncino",
    "542": "Cartelrosso",
    "543": "Facilsaglio",
    "544": "Legafascia",
    "545": "Bulbo",
    "546": "Ricaripila",
    "547": "Pulsantefuga",
    "548": "Bijoufuoco",
    "549": "Bijouacqua",
    "550": "Bijouelettro",
    "551": "Bijouerba",
    "552": "Bijoughiaccio",
    "553": "Bijoulotta",
    "554": "Bijouveleno",
    "555": "Bijouterra",
    "556": "Bijouvolante",
    "557": "Bijoupsico",
    "558": "Bijoucoleottero",
    "559": "Bijouroccia",
    "560": "Bijouspettro",
    "561": "Bijoudrago",
    "562": "Bijoubuio",
    "563": "Bijouacciaio",
    "564": "Bijounormale",
    "565": "Piumsalute",
    "566": "Piumpotenza",
    "567": "Piumtutela",
    "568": "Piumingegno",
    "569": "Piumintuito",
    "570": "Piumreazione",
    "571": "Piumabella",
    "572": "Fossiltappo",
    "573": "Fossilpiuma",
    "574": "Liberticket",
    "575": "Passabilia",
    "576": "Dream Ball",
    "577": "Pokégingillo",
    "578": "Portagadget",
    "579": "Teschio",
    "580": "Profumfungo",
    "581": "Granpepita",
    "582": "Trittiperla",
    "583": "Pezzo cometa",
    "584": "Soldantico",
    "585": "Ducatantico",
    "586": "Doblonantico",
    "587": "Vasantico",
    "588": "Bracciantico",
    "589": "Statuantica",
    "590": "Coronantica",
    "591": "Conostropoli",
    "592": "Supercolpo 2",
    "593": "Velocit\u00e0 X-2",
    "594": "Attacco Speciale X-2",
    "595": "Difesa Speciale X-2",
    "596": "Difesa X-2",
    "597": "Attacco X-2",
    "598": "Precisione X-2",
    "599": "Velocit\u00e0 X-3",
    "600": "Attacco Speciale X-3",
    "601": "Difesa Speciale X-3",
    "602": "Difesa X-3",
    "603": "Attacco X-3",
    "604": "Precisione X-3",
    "605": "Velocit\u00e0 X-6",
    "606": "Attacco Speciale X-6",
    "607": "Difesa Speciale X-6",
    "608": "Difesa X-6",
    "609": "Attacco X-6",
    "610": "Precisione X-6",
    "611": "Chiamabilit\u00e0",
    "612": "Lascioggetto",
    "613": "Chiamoggetto",
    "614": "Ripristino",
    "615": "Supercolpo 3",
    "616": "Chiarolite",
    "617": "Scurolite",
    "618": "MT093",
    "619": "MT094",
    "620": "MT095",
    "621": "Interpoké",
    "622": "???",
    "623": "Missiva 1",
    "624": "Missiva 2",
    "625": "Missiva 3",
    "626": "Interpoké",
    "627": "Box premi",
    "630": "Permesso",
    "633": "Carta Plasma",
    "634": "Pezza sporca",
    "635": "Acrocongegno",
    "636": "Oggetto perso",
    "637": "Oggetto perso",
    "639": "Vulneropolizza",
    "640": "Corpetto assalto",
    "644": "Lastraspiritello",
    "645": "Capsula abilit\u00e0",
    "646": "Dolcespuma",
    "647": "Bustina aromi",
    "648": "Muschioluce",
    "649": "Palla di neve",
    "650": "Visierantisabbia",
    "652": "Fertilflorido",
    "653": "Fertilsorpresa",
    "654": "Fertilcopioso",
    "655": "Fertilprodigio",
    "656": "Gengarite",
    "657": "Gardevoirite",
    "658": "Ampharosite",
    "659": "Venusaurite",
    "660": "Charizardite X",
    "661": "Blastoisite",
    "662": "Mewtwoite X",
    "663": "Mewtwoite Y",
    "664": "Blazikenite",
    "665": "Medichamite",
    "666": "Houndoomite",
    "667": "Aggronite",
    "668": "Banettite",
    "669": "Tyranitarite",
    "670": "Scizorite",
    "671": "Pinsirite",
    "672": "Aerodactylite",
    "673": "Lucarite",
    "674": "Abomasnowite",
    "675": "Kangaskhanite",
    "676": "Gyaradosite",
    "677": "Absolite",
    "678": "Charizardite Y",
    "679": "Alakazamite",
    "680": "Heracrossite",
    "681": "Mawilite",
    "682": "Manectricite",
    "683": "Garchompite",
    "684": "Latiasite",
    "685": "Latiosite",
    "686": "Baccarcad\u00e8",
    "687": "Baccalighia",
    "688": "Baccapane",
    "690": "MT096",
    "691": "MT097",
    "692": "MT098",
    "693": "MT099",
    "694": "MT100",
    "699": "Buono sconto",
    "704": "Strano ninnolo",
    "708": "Pan di Lumi",
    "709": "Yantafrollino",
    "710": "Fossilmascella",
    "711": "Fossilpinna",
    "715": "Bijoufolletto",
    "752": "Swampertite",
    "753": "Sceptilite",
    "754": "Sableyite",
    "755": "Altarite",
    "756": "Galladite",
    "757": "Audinite",
    "758": "Metagrossite",
    "759": "Sharpedite",
    "760": "Slowbroite",
    "761": "Steelixite",
    "762": "Pidgeotite",
    "763": "Glalite",
    "764": "Diancite",
    "767": "Cameruptite",
    "768": "Lopunnite",
    "769": "Salamencite",
    "770": "Beedrillite",
    "776": "Normium Z",
    "777": "Pirium Z",
    "778": "Idrium Z",
    "779": "Electrium Z",
    "780": "Herbium Z",
    "781": "Glacium Z",
    "782": "Luctium Z",
    "783": "Venenium Z",
    "784": "Terrium Z",
    "785": "Volantium Z",
    "786": "Psichium Z",
    "787": "Insectium Z",
    "788": "Petrium Z",
    "789": "Spectrium Z",
    "790": "Draconium Z",
    "791": "Obscurium Z",
    "792": "Metallium Z",
    "793": "Follectium Z",
    "794": "Pikacium Z",
    "795": "Tappo d'argento",
    "796": "Tappo d'oro",
    "798": "Deciduenium Z",
    "799": "Incineronium Z",
    "800": "Primarinium Z",
    "801": "Tapium Z",
    "802": "Marshadium Z",
    "803": "Aloraicium Z",
    "804": "Snorlactium Z",
    "805": "Eevium Z",
    "806": "Mewnium Z",
    "807": "Normium Z",
    "808": "Pirium Z",
    "809": "Idrium Z",
    "810": "Electrium Z",
    "811": "Herbium Z",
    "812": "Glacium Z",
    "813": "Luctium Z",
    "814": "Venenium Z",
    "815": "Terrium Z",
    "816": "Volantium Z",
    "817": "Psichium Z",
    "818": "Insectium Z",
    "819": "Petrium Z",
    "820": "Spectrium Z",
    "821": "Draconium Z",
    "822": "Obscurium Z",
    "823": "Metallium Z",
    "824": "Follectium Z",
    "825": "Pikacium Z",
    "826": "Deciduenium Z",
    "827": "Incineronium Z",
    "828": "Primarinium Z",
    "829": "Tapium Z",
    "830": "Marshadium Z",
    "831": "Aloraicium Z",
    "832": "Snorlactium Z",
    "833": "Eevium Z",
    "834": "Mewnium Z",
    "835": "Ashpikacium Z",
    "836": "Ashpikacium Z",
    "844": "Festicket",
    "846": "Fifasfera",
    "849": "Pietragelo",
    "851": "UC Ball",
    "852": "Malasada maxi",
    "853": "Nettare rosso",
    "854": "Nettare giallo",
    "855": "Nettare rosa",
    "856": "Nettare viola",
    "861": "Baccalampon argentata",
    "862": "Baccalampon dorata",
    "863": "Baccabana argentata",
    "864": "Baccabana dorata",
    "865": "Baccananas argentata",
    "866": "Baccananas dorata",
    "867": "???",
    "868": "???",
    "869": "???",
    "870": "???",
    "871": "???",
    "879": "Fissacampo",
    "880": "Smorzaurti",
    "881": "Elettroseme",
    "882": "Psicoseme",
    "883": "Nebbiaseme",
    "884": "Erbaseme",
    "885": "Molla elastica",
    "886": "Gessetto",
    "887": "Biglia",
    "888": "Orecchino",
    "889": "Vetro marino",
    "890": "Fogliadoro",
    "891": "Fogliargento",
    "892": "Pallina di fango",
    "893": "Tropiconchiglia",
    "894": "Foglialettera",
    "895": "Foglialettera",
    "896": "Bouquet",
    "897": "???",
    "898": "???",
    "899": "???",
    "900": "Profumo invito",
    "901": "Superprofumo",
    "902": "Profumo max",
    "903": "Plumbeosalatini",
    "904": "ROM Lotta",
    "905": "ROM Volante",
    "906": "ROM Veleno",
    "907": "ROM Terra",
    "908": "ROM Roccia",
    "909": "ROM Coleottero",
    "910": "ROM Spettro",
    "911": "ROM Acciaio",
    "912": "ROM Fuoco",
    "913": "ROM Acqua",
    "914": "ROM Erba",
    "915": "ROM Elettro",
    "916": "ROM Psico",
    "917": "ROM Ghiaccio",
    "918": "ROM Drago",
    "919": "ROM Buio",
    "920": "ROM Folletto",
    "921": "Solgaleium Z",
    "922": "Lunalium Z",
    "923": "Ultranecrozium Z",
    "924": "Mimikyum Z",
    "925": "Lycanrochium Z",
    "926": "Kommonium Z",
    "927": "Solgaleium Z",
    "928": "Lunalium Z",
    "929": "Ultranecrozium Z",
    "930": "Mimikyum Z",
    "931": "Lycanrochium Z",
    "932": "Kommonium Z",
    "949": "Cova'n'roll",
    "950": "Sconto'n'roll",
    "951": "Soldi'n'roll",
    "952": "Esp'n'roll",
    "953": "Affetto'n'roll",
    "954": "Incontra'n'roll",
    "955": "Repelle'n'roll",
    "956": "PS'n'roll",
    "957": "PP'n'roll",
    "958": "Stat'n'roll",
    "959": "Acchiappa'n'roll",
    "960": "Caramella vitalit\u00e0 S",
    "961": "Caramella potenza S",
    "962": "Caramella protezione S",
    "963": "Caramella acume S",
    "964": "Caramella intuito S",
    "965": "Caramella rapidit\u00e0 S",
    "966": "Caramella vitalit\u00e0 M",
    "967": "Caramella potenza M",
    "968": "Caramella protezione M",
    "969": "Caramella acume M",
    "970": "Caramella intuito M",
    "971": "Caramella rapidit\u00e0 M",
    "972": "Caramella vitalit\u00e0 L",
    "973": "Caramella potenza L",
    "974": "Caramella protezione L",
    "975": "Caramella acume L",
    "976": "Caramella intuito L",
    "977": "Caramella rapidit\u00e0 L",
    "978": "Caramella Bulbasaur",
    "979": "Caramella Charmander",
    "980": "Caramella Squirtle",
    "981": "Caramella Caterpie",
    "982": "Caramella Weedle",
    "983": "Caramella Pidgey",
    "984": "Caramella Rattata",
    "985": "Caramella Spearow",
    "986": "Caramella Ekans",
    "987": "Caramella Pikachu",
    "988": "Caramella Sandshrew",
    "989": "Caramella Nidoran[Character1:female ]",
    "990": "Caramella Nidoran[Character1:male ]",
    "991": "Caramella Clefairy",
    "992": "Caramella Vulpix",
    "993": "Caramella Jigglypuff",
    "994": "Caramella Zubat",
    "995": "Caramella Oddish",
    "996": "Caramella Paras",
    "997": "Caramella Venonat",
    "998": "Caramella Diglett",
    "999": "Caramella Meowth",
    "1000": "Caramella Psyduck",
    "1001": "Caramella Mankey",
    "1002": "Caramella Growlithe",
    "1003": "Caramella Poliwag",
    "1004": "Caramella Abra",
    "1005": "Caramella Machop",
    "1006": "Caramella Bellsprout",
    "1007": "Caramella Tentacool",
    "1008": "Caramella Geodude",
    "1009": "Caramella Ponyta",
    "1010": "Caramella Slowpoke",
    "1011": "Caramella Magnemite",
    "1012": "Caramella Farfetch'd",
    "1013": "Caramella Doduo",
    "1014": "Caramella Seel",
    "1015": "Caramella Grimer",
    "1016": "Caramella Shellder",
    "1017": "Caramella Gastly",
    "1018": "Caramella Onix",
    "1019": "Caramella Drowzee",
    "1020": "Caramella Krabby",
    "1021": "Caramella Voltorb",
    "1022": "Caramella Exeggcute",
    "1023": "Caramella Cubone",
    "1024": "Caramella Hitmonlee",
    "1025": "Caramella Hitmonchan",
    "1026": "Caramella Lickitung",
    "1027": "Caramella Koffing",
    "1028": "Caramella Rhyhorn",
    "1029": "Caramella Chansey",
    "1030": "Caramella Tangela",
    "1031": "Caramella Kangaskhan",
    "1032": "Caramella Horsea",
    "1033": "Caramella Goldeen",
    "1034": "Caramella Staryu",
    "1035": "Caramella Mr. Mime",
    "1036": "Caramella Scyther",
    "1037": "Caramella Jynx",
    "1038": "Caramella Electabuzz",
    "1039": "Caramella Pinsir",
    "1040": "Caramella Tauros",
    "1041": "Caramella Magikarp",
    "1042": "Caramella Lapras",
    "1043": "Caramella Ditto",
    "1044": "Caramella Eevee",
    "1045": "Caramella Porygon",
    "1046": "Caramella Omanyte",
    "1047": "Caramella Kabuto",
    "1048": "Caramella Aerodactyl",
    "1049": "Caramella Snorlax",
    "1050": "Caramella Articuno",
    "1051": "Caramella Zapdos",
    "1052": "Caramella Moltres",
    "1053": "Caramella Dratini",
    "1054": "Caramella Mewtwo",
    "1055": "Caramella Mew",
    "1056": "Caramella Meltan",
    "1057": "Caramella Magmar",
    "1058": "???",
    "1059": "???",
    "1060": "???",
    "1061": "???",
    "1062": "???",
    "1063": "???",
    "1064": "???",
    "1065": "???",
    "1066": "???",
    "1067": "???",
    "1068": "???",
    "1069": "???",
    "1070": "???",
    "1071": "???",
    "1072": "???",
    "1073": "???",
    "1084": "Salsicce",
    "1085": "Lattina Gustavo",
    "1086": "Scatoletta Bach",
    "1087": "Lattina fagioli",
    "1088": "Pan carré",
    "1089": "Pasta",
    "1090": "Funghi",
    "1091": "Coda affumicata",
    "1092": "Grosso porro",
    "1093": "Mela prelibata",
    "1094": "Ossi sottili",
    "1095": "Patate",
    "1096": "Erbe acquatiche",
    "1097": "Verdure",
    "1098": "Fritto misto",
    "1099": "Uovo sodo",
    "1103": "Spada rovinata",
    "1104": "Scudo rovinato",
    "1105": "Ornitofossile",
    "1106": "Ittiofossile",
    "1107": "Dracofossile",
    "1108": "Plesiofossile",
    "1109": "Bonbonfragola",
    "1110": "Bonboncuore",
    "1111": "Bonbonbosco",
    "1112": "Bonbonfoglio",
    "1113": "Bonbonfiore",
    "1114": "Bonbonstella",
    "1115": "Bonbonfiocco",
    "1116": "Dolcepomo",
    "1117": "Aspropomo",
    "1118": "Spray gola",
    "1119": "Zainofuga",
    "1120": "Scarponi robusti",
    "1121": "Fiascopolizza",
    "1122": "Distorservizio",
    "1123": "Superombrello",
    "1124": "Caram. esp. XS",
    "1125": "Caram. esp. S",
    "1126": "Caram. esp. M",
    "1127": "Caram. esp. L",
    "1128": "Caram. esp. XL",
    "1129": "Caramella Dynamax",
    "1130": "DT00",
    "1131": "DT01",
    "1132": "DT02",
    "1133": "DT03",
    "1134": "DT04",
    "1135": "DT05",
    "1136": "DT06",
    "1137": "DT07",
    "1138": "DT08",
    "1139": "DT09",
    "1140": "DT10",
    "1141": "DT11",
    "1142": "DT12",
    "1143": "DT13",
    "1144": "DT14",
    "1145": "DT15",
    "1146": "DT16",
    "1147": "DT17",
    "1148": "DT18",
    "1149": "DT19",
    "1150": "DT20",
    "1151": "DT21",
    "1152": "DT22",
    "1153": "DT23",
    "1154": "DT24",
    "1155": "DT25",
    "1156": "DT26",
    "1157": "DT27",
    "1158": "DT28",
    "1159": "DT29",
    "1160": "DT30",
    "1161": "DT31",
    "1162": "DT32",
    "1163": "DT33",
    "1164": "DT34",
    "1165": "DT35",
    "1166": "DT36",
    "1167": "DT37",
    "1168": "DT38",
    "1169": "DT39",
    "1170": "DT40",
    "1171": "DT41",
    "1172": "DT42",
    "1173": "DT43",
    "1174": "DT44",
    "1175": "DT45",
    "1176": "DT46",
    "1177": "DT47",
    "1178": "DT48",
    "1179": "DT49",
    "1180": "DT50",
    "1181": "DT51",
    "1182": "DT52",
    "1183": "DT53",
    "1184": "DT54",
    "1185": "DT55",
    "1186": "DT56",
    "1187": "DT57",
    "1188": "DT58",
    "1189": "DT59",
    "1190": "DT60",
    "1191": "DT61",
    "1192": "DT62",
    "1193": "DT63",
    "1194": "DT64",
    "1195": "DT65",
    "1196": "DT66",
    "1197": "DT67",
    "1198": "DT68",
    "1199": "DT69",
    "1200": "DT70",
    "1201": "DT71",
    "1202": "DT72",
    "1203": "DT73",
    "1204": "DT74",
    "1205": "DT75",
    "1206": "DT76",
    "1207": "DT77",
    "1208": "DT78",
    "1209": "DT79",
    "1210": "DT80",
    "1211": "DT81",
    "1212": "DT82",
    "1213": "DT83",
    "1214": "DT84",
    "1215": "DT85",
    "1216": "DT86",
    "1217": "DT87",
    "1218": "DT88",
    "1219": "DT89",
    "1220": "DT90",
    "1221": "DT91",
    "1222": "DT92",
    "1223": "DT93",
    "1224": "DT94",
    "1225": "DT95",
    "1226": "DT96",
    "1227": "DT97",
    "1228": "DT98",
    "1229": "DT99",
    "1230": "MT00",
    "1231": "Menta Schiva",
    "1232": "Menta Decisa",
    "1233": "Menta Birbona",
    "1234": "Menta Audace",
    "1235": "Menta Sicura",
    "1236": "Menta Scaltra",
    "1237": "Menta Fiacca",
    "1238": "Menta Placida",
    "1239": "Menta Modesta",
    "1240": "Menta Mite",
    "1241": "Menta Ardente",
    "1242": "Menta Quieta",
    "1243": "Menta Calma",
    "1244": "Menta Gentile",
    "1245": "Menta Cauta",
    "1246": "Menta Vivace",
    "1247": "Menta Timida",
    "1248": "Menta Lesta",
    "1249": "Menta Allegra",
    "1250": "Menta Ingenua",
    "1251": "Menta Seria",
    "1252": "Desioblocco",
    "1253": "Teiera rotta",
    "1254": "Teiera crepata",
    "1256": "Frutti",
    "1257": "Formaggio Mumu",
    "1258": "Spezie assortite",
    "1259": "Panna da cucina",
    "1260": "Curry precotto",
    "1261": "Latte di cocco",
    "1262": "Noodle precotti",
    "1263": "Hamburger",
    "1264": "Gigaspezia",
    "1265": "Desioframmento",
    "1268": "???",
    "1579": "Mielemax",
    "1580": "Fungomax",
    "1581": "Ramo Galarnoce",
    "1582": "Fascia Galarnoce",
    "1588": "Rocciarmatura",
    "1592": "Corona Galarnoce",
    "1604": "Rocciamax",
    "1606": "Cerotto abilit\u00e0",
    "1608": "Sferazen tempo",
    "1609": "Sferazen spazio",
    "1610": "Sferazen",
    "1611": "Filo dell'unione",
    "1612": "Muffin classico",
    "1613": "Bacca ghicocca",
    "1614": "Muffin Giubilo",
    "1615": "Multi extra",
    "1616": "Supercolpo",
    "1617": "Involtoscelta",
    "1618": "Doppiaceto",
    "1619": "Invertigratin",
    "1620": "Felcetonda",
    "1621": "Seme padronanza",
    "1622": "Poké Ball",
    "1623": "???",
    "1624": "Ghiaccio perenne",
    "1625": "Artiglio di Uxie",
    "1626": "Zanna di Azelf",
    "1627": "Piuma di Mesprit",
    "1628": "Ciottolo",
    "1629": "Flauto memordei",
    "1630": "Preparato",
    "1631": "Preparato buono",
    "1632": "Miele luccicante",
    "1633": "Spiga rigogliosa",
    "1634": "Fagiolo paffuto",
    "1635": "Fungo gommoso",
    "1636": "Minerale duro",
    "1637": "Legno",
    "1638": "Foglia regina",
    "1639": "Sferazen palude",
    "1640": "Poké Ball",
    "1641": "Mega Ball",
    "1642": "Ultra Ball",
    "1643": "Piuma Ball",
    "1644": "Pokékokeshi",
    "1645": "???",
    "1646": "Palla orba",
    "1647": "Scoppiosfera",
    "1648": "Sfera viscosa",
    "1649": "Pezzo stella",
    "1650": "Polpetta funghi",
    "1651": "Erba repellente",
    "1652": "Polpetta miele",
    "1653": "Polpetta spighe",
    "1654": "Polpetta fagioli",
    "1655": "Polpetta minerale",
    "1656": "Pozione",
    "1657": "Superpozione",
    "1658": "Iperpozione",
    "1659": "Pozione max",
    "1660": "Ricarica totale",
    "1661": "Preparato",
    "1662": "Preparato buono",
    "1663": "Preparato ottimo",
    "1664": "Dolce gateau",
    "1665": "Muffin Giubilo",
    "1666": "Cura totale",
    "1667": "Revitalizzante",
    "1668": "Revitalizzante max",
    "1669": "Tonico PP",
    "1670": "Tonico PP Max",
    "1671": "Furtivizzante",
    "1672": "???",
    "1673": "Offensiva extra",
    "1674": "Difensiva extra",
    "1675": "Supercolpo",
    "1676": "Elusione X",
    "1677": "Multi extra",
    "1678": "Sferazen foresta",
    "1679": "Pezzo di ferro",
    "1680": "???",
    "1681": "Ciottolo nero",
    "1682": "Ciottolo celeste",
    "1683": "???",
    "1684": "Palla di fango",
    "1685": "???",
    "1686": "Scoppiettalga",
    "1687": "Patata fumosa",
    "1688": "Ghicocca bacata",
    "1689": "Palla di neve",
    "1690": "Sfera viscosa",
    "1691": "Augite nera",
    "1692": "Blocco di torba",
    "1693": "Furtivizzante",
    "1694": "Porro officinale",
    "1695": "Revitalboccio",
    "1696": "Erba PP",
    "1697": "???",
    "1698": "???",
    "1699": "Amuleto Sostituto 2",
    "1700": "Amuleto Sostituto 3",
    "1701": "Danzaspaditola",
    "1702": "Ferroscudino",
    "1703": "Doppioteamillo",
    "1704": "Colpogone",
    "1705": "Rafano costiero",
    "1706": "Amuleto Sostituto 4",
    "1707": "Amuleto Sostituto 5",
    "1708": "Tartufo dolce",
    "1709": "Polpetta base",
    "1710": "Poké Ball",
    "1711": "Mega Ball",
    "1712": "Ultra Ball",
    "1713": "Piuma Ball",
    "1714": "???",
    "1715": "???",
    "1716": "Scoppiosfera",
    "1717": "Palla orba",
    "1718": "???",
    "1719": "???",
    "1720": "Pokékokeshi",
    "1721": "Sferazen vulcano",
    "1722": "Sferazen monte",
    "1723": "Sferazen neve",
    "1724": "Polpetta miele",
    "1725": "Polpetta spighe",
    "1726": "Polpetta fagioli",
    "1727": "Polpetta funghi",
    "1728": "Polpetta minerale",
    "1729": "Invertigratin",
    "1730": "Involtoscelta",
    "1731": "Doppiaceto",
    "1732": "Amuleto tutela 1",
    "1733": "Amuleto tutela 2",
    "1734": "Amuleto tutela 3",
    "1735": "Amuleto tutela 4",
    "1736": "Amuleto tutela 5",
    "1737": "Diario rovinato",
    "1738": "Amuleto salute 1",
    "1739": "Amuleto salute 2",
    "1740": "Amuleto salute 3",
    "1741": "Amuleto salute 4",
    "1742": "Amuleto salute 5",
    "1743": "Pezzo di lastra",
    "1744": "Esca Basculegion",
    "1745": "Vecchio diario",
    "1746": "Wing Ball",
    "1747": "Jet Ball",
    "1748": "Peso Ball",
    "1749": "Megaton Ball",
    "1750": "Gigaton Ball",
    "1751": "Wing Ball",
    "1752": "Jet Ball",
    "1753": "Peso Ball",
    "1754": "Baccaluppo",
    "1755": "Preparato ottimo",
    "1756": "Offensiva extra",
    "1757": "Difensiva extra",
    "1758": "Elusione X",
    "1759": "Sabbia impegno",
    "1760": "Ghiaia impegno",
    "1761": "Pietra impegno",
    "1762": "Roccia impegno",
    "1763": "Rimedio segreto",
    "1764": "Amuleto Sostituto 1",
    "1765": "Oggetto smarrito",
    "1766": "Oggetto smarrito",
    "1767": "Oggetto smarrito",
    "1768": "Oggetto smarrito",
    "1769": "Oggetto smarrito",
    "1770": "???",
    "1771": "Origin Ball",
    "1772": "???",
    "1773": "???",
    "1774": "???",
    "1775": "???",
    "1776": "Rocciorigine",
    "1777": "Adamasferoide",
    "1778": "Splendisferoide",
    "1779": "Grigiosferoide",
    "1780": "Lastraripristino",
    "1781": "???",
    "1782": "Kit faidaté",
    "1783": "Megaton Ball",
    "1784": "Gigaton Ball",
    "1785": "Strange Ball",
    "1786": "Pokédex",
    "1787": "Antica poesia 1",
    "1788": "Antica poesia 2",
    "1789": "Antica poesia 3",
    "1790": "Antica poesia 4",
    "1791": "???",
    "1792": "Antica poesia 5",
    "1793": "Antica poesia 6",
    "1794": "Antica poesia 7",
    "1795": "Antica poesia 8",
    "1796": "Antica poesia 9",
    "1797": "Antica poesia 10",
    "1798": "Antica poesia 11",
    "1799": "Antica poesia 12",
    "1800": "Antica poesia 13",
    "1801": "Antica poesia 14",
    "1802": "Antica poesia 15",
    "1803": "Antica poesia 16",
    "1804": "Antica poesia 17",
    "1805": "Antica poesia 18",
    "1806": "Antica poesia 19",
    "1807": "Antica poesia 20",
    "1808": "Frammento insolito S",
    "1809": "Frammento insolito L",
    "1810": "Trivella",
    "1811": "Piastra di Kanto",
    "1812": "Piastra di Johto",
    "1813": "Piastra del cuore",
    "1814": "Piastra arcobaleno",
    "1815": "Piastra dei venti",
    "1816": "Piastra dei mari",
    "1817": "Piastra delle terre",
    "1818": "Piastra dei cieli",
    "1819": "Piastra del gene",
    "1820": "Piastra degli esordi",
    "1821": "Piastra distorta",
    "1822": "Lettore DS",
    "1828": "Lastraleggenda",
    "1842": "Minibamb\u00f9",
    "1843": "Grande bamb\u00f9",
    "1861": "Armatura infausta",
    "1862": "Teralite Normale",
    "1863": "Teralite Fuoco",
    "1864": "Teralite Acqua",
    "1865": "Teralite Elettro",
    "1866": "Teralite Erba",
    "1867": "Teralite Ghiaccio",
    "1868": "Teralite Lotta",
    "1869": "Teralite Veleno",
    "1870": "Teralite Terra",
    "1871": "Teralite Volante",
    "1872": "Teralite Psico",
    "1873": "Teralite Coleottero",
    "1874": "Teralite Roccia",
    "1875": "Teralite Spettro",
    "1876": "Teralite Drago",
    "1877": "Teralite Buio",
    "1878": "Teralite Acciaio",
    "1879": "Teralite Folletto",
    "1880": "Capsula energetica",
    "1881": "Scudo abilit\u00e0",
    "1882": "Ciondolochiaro",
    "1883": "Foglia carbone",
    "1884": "Guantone",
    "1885": "Anonimanto",
    "1886": "Dado truccato",
    "2160": "MT100",
    "2161": "MT101",
    "2162": "MT102",
    "2163": "MT103",
    "2164": "MT104",
    "2165": "MT105",
    "2166": "MT106",
    "2167": "MT107",
    "2168": "MT108",
    "2169": "MT109",
    "2170": "MT110",
    "2171": "MT111",
    "2172": "MT112",
    "2173": "MT113",
    "2174": "MT114",
    "2175": "MT115",
    "2176": "MT116",
    "2177": "MT117",
    "2178": "MT118",
    "2179": "MT119",
    "2180": "MT120",
    "2181": "MT121",
    "2182": "MT122",
    "2183": "MT123",
    "2184": "MT124",
    "2185": "MT125",
    "2186": "MT126",
    "2187": "MT127",
    "2188": "MT128",
    "2189": "MT129",
    "2190": "MT130",
    "2191": "MT131",
    "2192": "MT132",
    "2193": "MT133",
    "2194": "MT134",
    "2195": "MT135",
    "2196": "MT136",
    "2197": "MT137",
    "2198": "MT138",
    "2199": "MT139",
    "2200": "MT140",
    "2201": "MT141",
    "2202": "MT142",
    "2203": "MT143",
    "2204": "MT144",
    "2205": "MT145",
    "2206": "MT146",
    "2207": "MT147",
    "2208": "MT148",
    "2209": "MT149",
    "2210": "MT150",
    "2211": "MT151",
    "2212": "MT152",
    "2213": "MT153",
    "2214": "MT154",
    "2215": "MT155",
    "2216": "MT156",
    "2217": "MT157",
    "2218": "MT158",
    "2219": "MT159",
    "2220": "MT160",
    "2221": "MT161",
    "2222": "MT162",
    "2223": "MT163",
    "2224": "MT164",
    "2225": "MT165",
    "2226": "MT166",
    "2227": "MT167",
    "2228": "MT168",
    "2229": "MT169",
    "2230": "MT170",
    "2231": "MT171",
    "2232": "MT172",
    "2233": "MT173",
    "2234": "MT174",
    "2235": "MT175",
    "2236": "MT176",
    "2237": "MT177",
    "2238": "MT178",
    "2239": "MT179",
    "2240": "MT180",
    "2241": "MT181",
    "2242": "MT182",
    "2243": "MT183",
    "2244": "MT184",
    "2245": "MT185",
    "2246": "MT186",
    "2247": "MT187",
    "2248": "MT188",
    "2249": "MT189",
    "2250": "MT190",
    "2251": "MT191",
    "2252": "MT192",
    "2253": "MT193",
    "2254": "MT194",
    "2255": "MT195",
    "2256": "MT196",
    "2257": "MT197",
    "2258": "MT198",
    "2259": "MT199",
    "2260": "MT200",
    "2261": "MT201",
    "2262": "MT202",
    "2263": "MT203",
    "2264": "MT204",
    "2265": "MT205",
    "2266": "MT206",
    "2267": "MT207",
    "2268": "MT208",
    "2269": "MT209",
    "2270": "MT210",
    "2271": "MT211",
    "2272": "MT212",
    "2273": "MT213",
    "2274": "MT214",
    "2275": "MT215",
    "2276": "MT216",
    "2277": "MT217",
    "2278": "MT218",
    "2279": "MT219",
    "2280": "MT220",
    "2281": "MT221",
    "2282": "MT222",
    "2283": "MT223",
    "2284": "MT224",
    "2285": "MT225",
    "2286": "MT226",
    "2287": "MT227",
    "2288": "MT228",
    "2289": "MT229",
    "2344": "Armatura fausta",
    "2345": "Simbolo del capo",
    "2401": "Piuma fatata",
    "2402": "Sciroppomo",
    "2403": "Tazza dozzinale",
    "2404": "Tazza eccezionale",
    "2405": "Maschera Turchese",
    "2406": "Maschera Fondamenta",
    "2407": "Maschera Pozzo",
    "2408": "Maschera Focolare",
    "2409": "Tessera chic verde",
    "2410": "Pezzo di cristallo",
    "2411": "Mochi della salute",
    "2412": "Mochi della potenza",
    "2413": "Mochi della tutela",
    "2414": "Mochi dell'ingegno",
    "2415": "Mochi dell'intuito",
    "2416": "Mochi della reazione",
    "2417": "Sedie semplici",
    "2418": "Sedie accademia",
    "2419": "Sedie accademia",
    "2420": "Sedie carine",
    "2421": "Sedie natura",
    "2422": "Sedie dispetto",
    "2423": "Sedie a quadri gialle",
    "2424": "Sedie a quadri viola",
    "2425": "Sedie a quadri rosse",
    "2426": "Sedie erba alta",
    "2427": "Sedie sfida",
    "2428": "Sedie mostruose",
    "2429": "Sedie a righe",
    "2430": "Sedie a rombi",
    "2431": "Sedie a pois",
    "2432": "Sedie lilla",
    "2433": "Sedie menta",
    "2434": "Sedie pesca",
    "2435": "Sedie gialle",
    "2436": "Sedie blu",
    "2437": "Sedie rosa",
    "2438": "Zanna di Ekans",
    "2439": "Artiglio di Sandshrew",
    "2440": "Pelo di Cleffa",
    "2441": "Pelo di Vulpix",
    "2442": "Muco di Poliwag",
    "2443": "Viticcio di Bellsprout",
    "2444": "Frammento di Geodude",
    "2445": "Gas di Koffing",
    "2446": "Zanna di Munchlax",
    "2447": "Pelo di Sentret",
    "2448": "Penna di Hoothoot",
    "2449": "Filo di Spinarak",
    "2450": "Pelo di Aipom",
    "2451": "Aculeo di Yanma",
    "2452": "Zanna di Gligar",
    "2453": "Lava di Slugma",
    "2454": "Pelo di Swinub",
    "2455": "Zanna di Poochyena",
    "2456": "Foglia di Lotad",
    "2457": "Picciolo di Seedot",
    "2458": "Frammento di Nosepass",
    "2459": "Fluido di Volbeat",
    "2460": "Fluido di Illumise",
    "2461": "Carapace di Corphish",
    "2462": "Squama di Feebas",
    "2463": "Frammento di Duskull",
    "2464": "Frammento di Chingling",
    "2465": "Sudore di Timburr",
    "2466": "Foglia di Sewaddle",
    "2467": "Penna di Ducklett",
    "2468": "Fuliggine di Litwick",
    "2469": "Artiglio di Mienfoo",
    "2470": "Penna di Vullaby",
    "2471": "Gemma di Carbink",
    "2472": "Ramo di Phantump",
    "2473": "Filo di Grubbin",
    "2474": "Polvere di Cutiefly",
    "2475": "Squama di Jangmo-o",
    "2476": "Piuma di Cramorant",
    "2477": "Seme di Morpeko",
    "2478": "Polvere di Poltchageist",
    "2479": "Mochi del ripristino",
    "2480": "Bastone Rotoselfie",
    "2481": "Brillamuleto",
    "2482": "Metallo composito",
    "2483": "Tessera chic blu",
    "2484": "Foglia di Oddish",
    "2485": "Aculeo di Tentacool",
    "2486": "Piuma di Doduo",
    "2487": "Pelo di Seel",
    "2488": "Guscio di Exeggcute",
    "2489": "Sudore di Tyrogue",
    "2490": "Zanna di Rhyhorn",
    "2491": "Inchiostro di Horsea",
    "2492": "Pelo di Elekid",
    "2493": "Pelo di Magby",
    "2494": "Lacrime di Lapras",
    "2495": "Frammento di Porygon",
    "2496": "Elettricit\u00e0 di Chinchou",
    "2497": "Pelo di Snubbull",
    "2498": "Penna di Skarmory",
    "2499": "Pittura di Smeargle",
    "2500": "Pelo di Plusle",
    "2501": "Pelo di Minun",
    "2502": "Guscio di Trapinch",
    "2503": "Artiglio di Beldum",
    "2504": "Punta di Cranidos",
    "2505": "Artiglio di Shieldon",
    "2506": "Crine di Blitzle",
    "2507": "Artiglio di Drilbur",
    "2508": "Lanugine di Cottonee",
    "2509": "Sudore di Scraggy",
    "2510": "Pelo di Minccino",
    "2511": "Gel di Solosis",
    "2512": "Filo di Joltik",
    "2513": "Frammento di Golett",
    "2514": "Pelo di Espurr",
    "2515": "Inchiostro di Inkay",
    "2516": "Penna di Pikipek",
    "2517": "Filo di Dewpider",
    "2518": "Fiore di Comfey",
    "2519": "Guscio di Minior",
    "2520": "Panna di Milcery",
    "2521": "Ruggine di Duraludon",
    "2522": "Spuntino per Articuno",
    "2523": "Spuntino per Zapdos",
    "2524": "Spuntino per Moltres",
    "2525": "Spuntino per Raikou",
    "2526": "Spuntino per Entei",
    "2527": "Spuntino per Suicune",
    "2528": "Spuntino per Lugia",
    "2529": "Spuntino per Ho-Oh",
    "2530": "Spuntino per Latias",
    "2531": "Spuntino per Latios",
    "2532": "Spuntino per Kyogre",
    "2533": "Spuntino per Groudon",
    "2534": "Spuntino per Rayquaza",
    "2535": "Spuntino per Cobalion",
    "2536": "Spuntino per Terrakion",
    "2537": "Spuntino per Virizion",
    "2538": "Spuntino per Reshiram",
    "2539": "Spuntino per Zekrom",
    "2540": "Spuntino per Kyurem",
    "2541": "Spuntino per Solgaleo",
    "2542": "Spuntino per Lunala",
    "2543": "Spuntino per Necrozma",
    "2544": "Spuntino per Kubfu",
    "2545": "Spuntino per Glastrier",
    "2546": "Spuntino per Spectrier",
    "2547": "Disco indaco",
    "2548": "Stecchino infuocato",
    "2549": "Teralite Astrale",
    "2550": "Chesnaughtite",
    "2551": "Clefablite",
    "2552": "Delphoxite",
    "2553": "Dragoninite",
    "2554": "Drampanite",
    "2555": "Emboarite",
    "2556": "Excadrillite",
    "2557": "Feraligite",
    "2558": "Floettite",
    "2559": "Greninjite",
    "2560": "Golurkite",
    "2561": "Hawluchanite",
    "2562": "Meganiumite",
    "2563": "Meowsticite",
    "2564": "Starmiite",
    "2565": "Victreebelite",
    "2566": "Skarmoryite",
    "2567": "Chandelurite",
    "2568": "Zygardite",
    "2569": "Glimmoranite",
    "2570": "Crabominite",
    "2571": "Raichuite X",
    "2572": "Raichuite Y",
    "2573": "Chimechite",
    "2574": "Absolite Z",
    "2575": "Staraptorite",
    "2576": "Garchompite Z",
    "2577": "Lucarionite Z",
    "2578": "Heatranite",
    "2579": "Darkranite",
    "2580": "Golisopite",
    "2581": "Magearnite",
    "2582": "Zeraorite",
    "2583": "Scovillainite",
    "2584": "Tatsugirite",
    "2585": "Baxcalibrite"
}
export default itemsIta;